import React from 'react';
import './Header.css'; // Create this CSS file

function Header({ toggleSidebar }) {
  return (
    <header className="header">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-auto d-md-none">
            <button className="btn btn-link text-dark p-2" onClick={toggleSidebar}>
              <i className="bi bi-list fs-4"></i>
            </button>
          </div>
          
          <div className="col">
            <div className="d-flex align-items-center">
              <div className="header-title">
                <h4 className="mb-0 fw-bold">EABC-B2B-NETWORK</h4>
                <small className="text-muted">Business Networking Platform</small>
              </div>
            </div>
          </div>
          
          <div className="col-auto">
            <div className="header-actions d-flex align-items-center gap-3">
              <div className="search-container d-none d-lg-block">
                <div className="input-group">
                  <span className="input-group-text bg-transparent border-end-0">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input 
                    type="text" 
                    className="form-control border-start-0" 
                    placeholder="Search..."
                    style={{boxShadow: 'none'}}
                  />
                </div>
              </div>
              
              {/* <div className="notification-bell position-relative">
                <button className="btn btn-light rounded-circle p-2 position-relative">
                  <i className="bi bi-bell fs-5"></i>
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    3
                  </span>
                </button>
              </div> */}
              
              <div className="user-menu">
                <div className="dropdown">
                  <button 
                    className="btn btn-light rounded-circle p-0" 
                    type="button" 
                    data-bs-toggle="dropdown"
                    style={{width: '45px', height: '45px'}}
                  >
                    {/* <img 
                      src="https://ui-avatars.com/api/?name=User&background=007bff&color=white" 
                      alt="User" 
                      className="rounded-circle"
                      style={{width: '100%', height: '100%', objectFit: 'cover'}}
                    /> */}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li><h6 className="dropdown-header">Welcome, User!</h6></li>
                    <li><a className="dropdown-item" href="/profile">
                      <i className="bi bi-person me-2"></i>My Profile
                    </a></li>
                    <li><a className="dropdown-item" href="#">
                      <i className="bi bi-gear me-2"></i>Settings
                    </a></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><a className="dropdown-item text-danger" href="#">
                      <i className="bi bi-box-arrow-right me-2"></i>Logout
                    </a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;